import { render, staticRenderFns } from "./register-driver.vue?vue&type=template&id=04aadfeb&scoped=true&"
import script from "./register-driver.vue?vue&type=script&lang=js&"
export * from "./register-driver.vue?vue&type=script&lang=js&"
import style0 from "./register-driver.vue?vue&type=style&index=0&id=04aadfeb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04aadfeb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAlert,VBtn,VForm,VSelect,VTextField})
